import { render, staticRenderFns } from "./WaterPressureSensorsSingle.vue?vue&type=template&id=2b7b275c&"
import script from "./WaterPressureSensorsSingle.vue?vue&type=script&lang=js&"
export * from "./WaterPressureSensorsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports